import React, { useContext } from "react";
import { AppContext } from "../Provider/Provider";

const BarraConsumo = ({ name }) => {
  const [valoresConsumoState, setValoresConsumoState] = useContext(AppContext);


  let porcentaje = 0;
  let valorKWHxCat = valoresConsumoState.ValoresCategoriaCard[name].kWh; // valor de kwh de cada categoria 
  
  let valorTotalKWH = valoresConsumoState.TotalkWhBim; // Valor total de kwh bimestral (100%)
  let tempRes = (valorKWHxCat/valorTotalKWH)*100;
 
  porcentaje = Math.round(tempRes);

  /** se usa para la barra de porcentaje */
  let porcentajeParaMostrar = porcentaje + '%';

  return (
    <div className={"w-full grid grid-cols-12 "}>
      <span className={"w-max -mb-2 mt-2 | text-green-700"}>{name}</span>
      <div className={"col-start-1 col-end-11 | shadow w-full bg-gray-200 mt-2 has-tooltip"}>
        <div
          className={`overflow-hidden bg-gradient-to-r from-green-400 via-green-600 to-green-400 | 
          text-xs leading-none py-2 text-center text-white`}
          style={{ width: porcentajeParaMostrar }}
          ></div>
      <span className='tooltip rounded shadow-lg p-1 bg-gray-600 text-white -mt-8'>{tempRes} %</span>
      </div>
      
      <span className={"col-start-11 | ml-2 pt-1 | font-semibold"}>{porcentajeParaMostrar}</span>
    </div>
  );
};

export default BarraConsumo;
